<div class="container">
  <h2 class="page-heading">Products</h2>
  <div *ngIf="cartItems$ | async as cartItems">
    <div *ngIf="cartItems?.length !== 0">
      <span class="number-of-items">
        {{ cartItems?.length }} items in your bag.
      </span>
      <div class="container">
        <div class="list-container">
          <div class="list-header">
            <span class="header-item">Product</span>
            <span class="header-item">Quantity</span>
            <span class="header-item">Total Price</span>
            <span></span>
          </div>

          <div class="products-container">
            <div *ngFor="let cartItem of cartItems" class="card-container">
              <!-- <div class="game-image-container">
                <img
                  class="game-image"
                  [src]="cartItem.productVariant?.customFields?.mainAsset?.source"
                  [alt]="cartItem.productVariant?.name"
                />
              </div> -->

              <div class="game-stats">
                <div class="game-rating">
                  <span>Rating:</span>
                  <div nz-flex nzAlign="center" nzGap="2px">
                    <span nz-icon nzType="ng-zorro:star"></span>
                    <span nz-icon nzType="ng-zorro:star"></span>
                    <span nz-icon nzType="ng-zorro:star"></span>
                    <span nz-icon nzType="ng-zorro:star"></span>
                  </div>
                </div>

                <div class="truncate">
                  <h2 class="game-name">{{ cartItem.productVariant.name }}</h2>
                </div>
              </div>

              <div class="quantity-selector">
                <span
                  class="add"
                  (click)="increaseQuantity(cartItem)"
                  nz-icon
                  nzType="ng-zorro:plus"
                ></span>
                <span class="quantity">{{ cartItem.quantity }}</span>
                <span
                  class="minus"
                  nz-icon
                  nzType="ng-zorro:minus"
                  (click)="decreaseQuantity(cartItem)"
                ></span>
              </div>

              <div class="price-container">
                <span>Price: &nbsp;</span>
                <span class="price"
                  >{{ cartItem.linePrice | currencyLocale }}
                </span>
              </div>

              <span
                nz-icon
                nzType="ng-zorro:cross"
                class="remove-Item"
                (click)="removeProduct(cartItem)"
              >
              </span>
            </div>
          </div>

          <div class="w-full" nz-flex nzJustify="end">
            <div
              class="billing-container"
              nz-flex
              [nzVertical]="true"
              nzGap="small"
            >
              <div nz-flex nzJustify="space-between">
                <span>Items:</span>
                <span>{{ cartItems.length }}</span>
              </div>
              <div nz-flex nzJustify="space-between">
                <span>Price:</span>
                <span *ngIf="cartTotal$ | async as total">
                  {{ total | currencyLocale }}
                </span>
              </div>
              <nz-divider class="divider"></nz-divider>
              <div nz-flex nzJustify="space-between">
                <span class="text-pink">Total Price</span>
                <span class="text-pink" *ngIf="cartTotal$ | async as total">
                  {{ total | currencyLocale }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="summary-container">
          <div class="header">
            <h2 class="heading">Summary</h2>
          </div>
          <div
            class="summary-billing-container"
            nz-flex
            [nzVertical]="true"
            nzGap="small"
          >
            <div nz-flex nzJustify="space-between">
              <span>Official Price:</span>
              <span *ngIf="cartTotal$ | async as total">
                {{ total | currencyLocale }}
              </span>
            </div>
            <div nz-flex nzJustify="space-between">
              <span>Discount</span>
              <span>{{ -0 | currencyLocale }} </span>
            </div>
            <nz-divider class="divider"></nz-divider>
            <div nz-flex nzJustify="space-between">
              <span class="text-pink">Subtotal</span>
              <span class="text-pink" *ngIf="cartTotal$ | async as total">
                {{ total | currencyLocale }}
              </span>
            </div>
            <button nz-button class="order-btn" routerLink="/payment">
              Place Order
            </button>
          </div>
        </div>
      </div>
      <div class="section-container">
        <h2 class="section-heading">
          Customers Who Bought This Item Also Bought
        </h2>
        <div
          class="suggested-items-container"
          *ngIf="
            (collectionService.getLoaderState(SLUGS.BEST_SELLER) | async) ===
              false &&
            (collection$ | async) &&
            (collection$ | async)?.length !== 0
          "
        >
          <!-- <app-game-card-alpha
            *ngFor="let item of collection$ | async | slice: 0 : 4"
            [data]="item"
          >
          </app-game-card-alpha> -->
        </div>
        <div
          *ngIf="
            (collectionService.getLoaderState(SLUGS.BEST_SELLER) | async) ===
              false && (collection$ | async)?.length === 0
          "
        >
          <app-no-items-found></app-no-items-found>
        </div>
        <div
          *ngIf="collectionService.getLoaderState(SLUGS.BEST_SELLER) | async"
        >
          Loading...!
        </div>
      </div>
    </div>

    <ng-container
      *ngIf="cartItems?.length === 0"
      [ngTemplateOutlet]="emptyCart"
    >
    </ng-container>
  </div>
</div>

<ng-template #emptyCart>
  <app-no-items-found title="Your cart is empty!"></app-no-items-found>
</ng-template>
